import React, { Component, PropTypes } from 'react';
import Modal from './Modal';
import DataTable from './DataTable';
import Spinner from './Spinner';
import { observer, inject } from 'mobx-react';
import { observable, toJS } from 'mobx';
import { auditHistory as api } from '../actions/api';
import { getDisplayDate } from '../libs/date'
import ReactModal from 'react-modal';

const styles = {
  modal: {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    content: {
      backgroundColor: 'white',
      position: 'fixed',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  },
};

@inject('userStore')
@observer
class AuditHistory extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  }

  columns = [
    { key: 'column_name', label: 'Column Name' },
    { key: 'previous_value', label: 'Previous Value' },
    { key: 'new_value', label: 'New Value' },
    { key: 'date_modified', label: 'Date Modified' },
    { key: 'modified_by', label: 'Modified By' },
  ];

  @observable data = [];
  @observable isLoading = false;

  componentDidMount() {
    const { audit_table, link, userStore } = this.props;
    this.isLoading = true;
    api.getAuditHistory(audit_table, link).then(res => {
      this.data = res;
      this.isLoading = false;
    }).catch(err => {
      this.isLoading = false;
      console.log(err);
      // this.context.notify.error({message: err.toString()});
    })
  }

  render() {
    const { title, onRequestClose, audit_table, link, userStore } = this.props;
    if (!audit_table || !link) return null;

    return (
      <ReactModal
        isOpen
        onRequestClose={onRequestClose}
        className="Modal"
        style={styles.modal}
        contentLabel={title}
        closeTimeoutMS={200}
        ariaHideApp={false}
      >
        <div className="modalHeader">
          <div className="modalHeaderTitle">{title}</div>
          <a className="modalHeaderClose" onClick={onRequestClose}>
            <i className="fa fa-close" aria-hidden="true"></i>
          </a>
        </div>
        <div className='modalChildren'>
          {userStore.isLoading || this.isLoading ? <Spinner /> :
            <DataTable
              columns={this.columns} slug={''}
              data={Object.assign([], toJS(this.data)).map(item => {
                item.date_modified = getDisplayDate(item.date_modified);
                let user = userStore.findById(item.modified_by);
                if (!!user) item.modified_by = user.name;
                return item;
              })}
            />
          }
          <br />
        </div>
      </ReactModal>
    );
  }
}

export default AuditHistory;


// WEBPACK FOOTER //
// ./src/components/AuditHistory.js